import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { ProblemDetails } from "../types/utils";

export function isFetchBaseQueryError(error: unknown): error is FetchBaseQueryError {
    return typeof error == "object" && error != null && "status" in error;
}


/** funcion de ejemplo para errores con campos extras en el error */
export function isErrorWithMessage(error: unknown): error is { message: string } {
    return (
        typeof error == "object" &&
        error != null &&
        "message" in error &&
        typeof (error as any).message === "string");
}

export function parseErrorToDetailProblem(error: FetchBaseQueryError): ProblemDetails | null {
    if(error.data)
        if(typeof error.data == "object" && "problemDetails" in error.data)
            return error.data.problemDetails as ProblemDetails;

    return null;
}

export function getErrorMessage(error: unknown): string {
    let errorMessage = "Un error a ocurrido. Intente mas tarde";

    if(isFetchBaseQueryError(error)) {
        const problemDetails = parseErrorToDetailProblem(error);
        if(problemDetails) {
            if(problemDetails.error.length > 0) {
                errorMessage = problemDetails.error[0].description;
            }
            else {
                errorMessage = problemDetails.title
            }
        }
    }
    return errorMessage;
}